import React from "react";
import "./style.css";
import { Icon } from "@mui/material";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container grid2">
          <div className="box">
            <h1>% Deals On</h1>
            <p>© 2023 dealson.netlify.app</p>
            {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor libero id et, in gravida. Sit diam duis mauris nulla cursus. Erat et lectus vel ut sollicitudin elit at amet.</p> */}
            {/* <div className='icon d_flex'>
              <div className='img d_flex'>
                <i class='fa-brands fa-google-play'></i>
                <span>Google Play</span>
              </div>
              <div className='img d_flex'>
                <i class='fa-brands fa-app-store-ios'></i>
                <span>App Store</span>
              </div>
            </div> */}
          </div>

          <div className="box">
            <h2>Quick Links</h2>
            <ul className="quickLink">
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=6fab35bd7d8a2cc88839346536d19004&camp=3638&creative=24630&node=976419031"
                >
                  Electronics
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=53fec1c14faa9f66cbb0b862f0c7b1ae&camp=3638&creative=24630&node=976389031"
                >
                  Books
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=bbbac07e32cf3a510dcf5fce66fd347a&camp=3638&creative=24630&node=1983396031"
                >
                  Shoes
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=0bcc390c0cdb018f0b88be92c9620303&camp=3638&creative=24630&node=1350385031"
                >
                  Health &amp; Beauty
                </a>
              </li>
            </ul>
          </div>
          <div className="box">
            {/* <h2>Customer Care</h2> */}
            <ul className="quickLink">
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=9cd492ec49c1d0d925ebba76522dd6c9&camp=3638&creative=24630&node=2454181031"
                >
                  Pet Supplies
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=97d6766535f6f7a3458a4bdcdba262e7&camp=3638&creative=24630&node=976442031"
                >
                  Kitchen &amp; Housewares
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=0090d38bb17edf2969c3c3e93b1d22d5&camp=3638&creative=24630&node=976416031"
                >
                  Movies &amp; TV
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=bf89fef3ece5944b1716780cf5d90905&camp=3638&creative=24630&node=1350387031"
                >
                  Watches
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=7bb23e2e8060e4c1586b8d99fbc5a4ae&camp=3638&creative=24630&node=976392031"
                >
                  Computers
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=3f4e345e72a1716896c941d6e5826e3a&camp=3638&creative=24630&node=1951048031"
                >
                  Jewelry
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.amazon.in/b?_encoding=UTF8&tag=sam14303-21&linkCode=ur2&linkId=c4afe2fea43757fdb3f7eeb094ebf91b&camp=3638&creative=24630&node=2454169031"
                >
                  Luggage
                </a>
              </li>
            </ul>
          </div>
          <div className="box">
            <h2>Contact Us</h2>
            <ul className="quickLink">
              {/* <li>
                70 Washington Square South, New York, NY 10012, United States{" "}
              </li> */}
              <li>
                <a href="mailto:shoppingclub28@gmail.com"  class="email-link">
                 Email:
                  shoppingclub28@gmail.com
                </a>
          </li>
              {/* <li>Phone: +1 1123 456 780</li> */}
              <li>
                <a href="https://t.me/hoottdeals">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    fill="currentColor"
                    class="bi bi-telegram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
       
      </footer>
    </>
  );
};

export default Footer;
